var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSigningCheck(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50px",
    height: "49px",
    viewBox: "0 0 50 49",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Kompetens_CMYK") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 49 49.9661017 49 49.9661017 0.625172414 0 0.625172414"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Checkout-1.0",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "19--Checkout-10",
    transform: "translate(-350.000000, -261.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Kompetens_CMYK",
    transform: "translate(350.000000, 261.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.52372881,46.4883276 L47.4686441,46.4883276 L47.4686441,3.09122414 L2.52372881,3.09122414 L2.52372881,46.4883276 Z M-0.0186440678,49.0228103 L50.0110169,49.0228103 L50.0110169,0.556741379 L-0.0186440678,0.556741379 L-0.0186440678,49.0228103 Z",
    id: "Fill-1",
    fill: "#005C9C",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-4",
    fill: "#DF0314",
    points: "19.6025424 22.1657414 17.709322 23.8570862 24.9889831 31.9505345 40.920339 14.2446379 39.0288136 12.5516034 24.9889831 28.1538793 19.6025424 22.1657414"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-5",
    fill: "#005C9C",
    points: "37.7245763 23.5098621 35.1822034 23.5098621 35.1822034 36.2050862 14.809322 36.2050862 14.809322 15.9038793 32.7084746 15.9038793 32.7084746 13.3693966 12.2669492 13.3693966 12.2669492 38.739569 37.7245763 38.739569 37.7245763 23.5098621"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSigningCheck);
export default __webpack_public_path__ + "static/media/signing-check.b1174c8600d4f6cadb76a44170ad159d.svg";
export { ForwardRef as ReactComponent };